export class LocalStorageItem {
  constructor(
    private key: string,
    defaultValue: string | null = null
  ) {
    if (defaultValue !== null && this.get() === null) {
      this.set(defaultValue)
    }
  }

  get(): string | null {
    return localStorage.getItem(this.key)
  }

  set(value: string) {
    localStorage.setItem(this.key, value)
  }

  remove() {
    localStorage.removeItem(this.key)
  }
}
